<template>
  <div class="w-5rem  sideBar">
      <ul class="px-0 py-3 m-0">
        <li  :class="`btns sidebarLis mx-2 text-center ${index === activeIndex ? 'active' : ''}`" v-for="(item, index) of sidebarBtnsArray" v-bind:key="index">
            <a  class="clickIcons" @click="settabclick(item.text , index)">
              <span class="d-block" v-html="item.icon"></span>
              <span class="sidebarBtnstext d-block" >{{item.text}}</span>
            </a>
        </li>
        <li v-if="getActiveTab === 'Settings'" :class="`btns sidebarLis mx-2 text-center ${getActiveTab === 'Settings' ? 'active' : ''}`" >
            <a  class="clickIcons">
              <span class="d-block" v-html="sidebarBtns.at(-1).icon"></span>
              <span class="sidebarBtnstext d-block" >{{sidebarBtns.at(-1).text}}</span>
            </a>
        </li>
      </ul>
  </div>
</template>

<script>
  import {SidebarIcons} from "../commonJSON" 
export default {
  
  name: 'sideBar',
  data(){
    return {
      sidebarBtns : SidebarIcons,
      activeIndex: 0
    }
  },
  computed:{
    sidebarBtnsArray(){
      return this.sidebarBtns.filter(x => x.show === true);
    },
    getActiveTab(){
      return this.$store.getters.getActiveSidePanel
    }
  },
  watch: {
        "$store.state.currentActiveSidePanel" : {
            handler(updatedValues) {        
                    console.log("currentActiveSidePanel updated : " + updatedValues)
                    if(updatedValues === "Settings"){
                      this.activeIndex = 18;                     
                    }
                    this.$emit('setTab' , updatedValues)
            },
            deep: true,
            immediate: true

        }
       
    },
  methods:{
    settabclick(text , index){
      
      this.activeIndex = index
      // this.$emit('setTab' , text)
      // console.log("asdasdasdasd")
      this.$store.dispatch('set_active_sidepanel', text)
    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.smallSideBar{
  width: 5rem;
  background-color: aliceblue;
  height: 100%;
}
.w-5rem{
  width: 5rem;
}
.sideBar{
  background-color: rgb(221 226 229);
}
.clickIcons{
  color: rgb(73 80 87);
  display: block;
  cursor: pointer;
  text-decoration: none;
}
.sidebarBtnstext{
  font-size: 10.4px;
  font-weight: 500;
}
.sidebarLis{
  padding-bottom: .75rem;
    padding-top: .75rem;
    list-style-type: none;
}
.sidebarLis.active{
  background-color: #fff;
  border-radius: 5px;
}
.sidebarLis:last-child{
  padding-bottom: 0;
}
</style>
